module.exports = "https://store.zigzag.kr/resources/arm64/20260325-1542-73037f8f6a_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";